import { clientCaseFactFindLetterOfAuthorityInformationRequestApi } from './informationRequest';
import { clientCaseFactFindLetterOfAuthorityPrintApi } from './print';
import { clientCaseFactFindLetterOfAuthorityTrackingApi } from './tracking';

export function clientCaseFactFindLetterOfAuthorityApi(path: string) {
  return {
    path,
    informationRequest: () =>
      clientCaseFactFindLetterOfAuthorityInformationRequestApi(`${path}/information-request`),
    print: () => clientCaseFactFindLetterOfAuthorityPrintApi(`${path}/print`),
    tracking: () => clientCaseFactFindLetterOfAuthorityTrackingApi(`${path}/tracking`),
  };
}
